import { MarketReport, NewsReport, MarketIndicator, MarketOutlook, BaseMarketEvent, NewsContent, SecurityNewsResponse, EventProperty, EventsData, EventsResponse, Earnings, EventGroup, RatingsChange, Dividends, MarketEvent, Events, EventsDateRange } from '../../../domain/market-info/market-info.domain';
import { AccountDivisionType } from '../../../domain/account.domain';

export {
  MarketReport,
  NewsReport,
  MarketIndicator,
  MarketOutlook,
  BaseMarketEvent,
  NewsContent,
  SecurityNewsResponse,
  EventsData,
  EventsResponse,
  EventProperty,
  Earnings,
  EventGroup,
  RatingsChange,
  Dividends,
  MarketEvent,
  Events,
  EventsDateRange
};

export enum EventType {
  EARNINGS = 'EARNINGS',
  DIVIDENDS = 'DIVIDENDS',
  RATING_CHANGES = 'RATING_CHANGES',
  NEWS = 'NEWS'
}
export class EventTypeHelper {
  static toCamelCase(eventType: EventType): EventProperty {
    if (eventType === EventType.RATING_CHANGES) {
      return 'ratingsChange';
    }
    return eventType !== undefined ? eventType.toString().toLowerCase() as EventProperty : undefined;
  }

  static toUpperCase(eventProperty: EventProperty): EventType {
    if (eventProperty === 'ratingsChange') {
      return EventType.RATING_CHANGES;
    }
    return eventProperty !== undefined ? eventProperty.toString().toUpperCase() as  EventType : undefined;
  }
}

export type EventPeriod = 'PREVIOUS_WEEK' | 'NEXT_WEEK' | undefined;

export interface AdvisorName {
  familyName: string;
  fullName: string;
  givenName: string;
  middleName: string;
}

export interface AdvisorProfile {
  name: AdvisorName;
  businessTitle?: string;
  photoUrl: string;
  email: string;
  websiteUrl: string;
  workPhone: string;
  rrCode: string;
  lob: AccountDivisionType;
  preferredName?: AdvisorName;
}

